import axios from "axios";
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from "feather-icons-react";
import Select from "react-select";
import { toast } from "react-toastify";

const GIFT_FIELD_RULES = {
    supplierId: { label: "Le fournisseur", required: true },
    entitled_gift: { label: "Le titre du don", required: true, minLength: 2, maxLength: 100 },
    quantity: { label: "La quantité", required: false },
    specification: { label: "La spécification", required: false, maxLength: 1000 },
};

class GiftForm extends Component {
    state = {
        id: "",
        supplierId: "",
        entitled_gift: "",
        quantity: "",
        specification: "",
        file: null,
        oldFile: "",
        error: "",
        errors: {},
        suppliers: [],
        title: "",
        btn: false,
    };

    handleInput = (e) => {
        const { name, value } = e.target;

        this.setState((state) => ({
            [name]: value,
            error: "",
            errors: { ...state.errors, [name]: "" },
        }));
    };

    handleFile = (e) => {
        this.setState({
            file: e.target.files[0] || null,
            error: "",
        });
    };

    validate = () => {
        const errors = {};

        Object.entries(GIFT_FIELD_RULES).forEach(([name, rule]) => {
            const value = String(this.state[name] ?? "").trim();

            if (rule.required && !value) {
                errors[name] = `${rule.label} est obligatoire.`;
            } else if (value && rule.minLength && value.length < rule.minLength) {
                errors[name] = `${rule.label} doit contenir au moins ${rule.minLength} caractères.`;
            } else if (value && rule.maxLength && value.length > rule.maxLength) {
                errors[name] = `${rule.label} ne peut pas dépasser ${rule.maxLength} caractères.`;
            }
        });

        if (this.state.quantity !== "" && this.state.quantity !== null) {
            const quantity = Number(this.state.quantity);
            if (!Number.isFinite(quantity) || quantity < 0) {
                errors.quantity = "La quantité doit être un nombre positif.";
            }
        }

        return errors;
    };

    storeGift = async (val = null) => {
        const errors = this.validate();

        if (Object.keys(errors).length) {
            this.setState({
                errors,
                error: Object.values(errors)[0],
            });
            return;
        }

        try {
            this.setState({ btn: true, error: "", errors: {} });

            const formData = new FormData();

            formData.append("supplierId", this.state.supplierId);
            formData.append("entitled_gift", String(this.state.entitled_gift || "").trim());
            formData.append("quantity", this.state.quantity ? this.state.quantity : "");
            formData.append("specification", String(this.state.specification || "").trim());
            formData.append("operation", this.state.id ? (val === 1 ? "Archiver" : "Editer") : "Ajouter");

            if (this.state.file) {
                formData.append("file", this.state.file);
            }

            const request = this.state.id
                ? axios.put(`gifts/${this.state.id}`, formData)
                : axios.post("gifts", formData);

            const response = await request;

            toast(response?.data?.msg || "Opération effectuée avec succès.", {
                theme: "light",
                style: { backgroundColor: "blue", color: "white" },
            });

            this.setState({ btn: false });
            this.props.showModal(null, false, 1);
        } catch (error) {
            const message = error.response?.data?.msg || "Une erreur est survenue.";

            this.setState({
                error: message,
                btn: false,
            });

            toast(message, {
                theme: "light",
                style: { backgroundColor: "red", color: "white" },
            });
        }
    };

    async suppliers() {
        const request = await axios.get("suppliers");

        if (request.status === 200) {
            this.setState({ suppliers: request.data });
        }
    }

    edit = () => {
        this.form();
        this.suppliers();
    };

    form = () => {
        this.setState({
            id: this.props.formData ? this.props.formData.id : "",
            supplierId: this.props.formData?.supplier?.id || "",
            entitled_gift: this.props.formData ? this.props.formData.entitled_gift : "",
            quantity: this.props.formData ? this.props.formData.quantity : "",
            specification: this.props.formData ? this.props.formData.specification : "",
            file: null,
            oldFile: this.props.formData ? this.props.formData.file : "",
            title: this.props.formData && this.props.formData.id ? "Modifier le don" : "Ajouter un don",
            errors: {},
            error: "",
            btn: false,
        });
    };

    render() {
        const selectMenuProps = {
            menuPortalTarget: typeof document !== "undefined" ? document.body : null,
            menuPosition: "fixed",
            classNamePrefix: "student-select",
            styles: { menuPortal: (base) => ({ ...base, zIndex: 1060 }) },
        };

        const optionsuppliers = this.state.suppliers.map((supplier) => ({
            value: supplier.id,
            label: supplier.name,
        }));

        return (
            <div>
                <Modal
                    show={this.props.isModal}
                    onHide={this.props.showModal}
                    size="lg"
                    dialogClassName="sectionclasse-form"
                    contentClassName="student-form-modal student-form-modal--compact"
                    onEntered={this.edit}
                    backdrop="static"
                >
                    <Modal.Header>
                        <div className="student-form__heading">
                            <span className="student-form__heading-icon">
                                <FeatherIcon icon="gift" size="20" />
                            </span>
                            <div>
                                <span className="student-form__eyebrow">Gestion des dons</span>
                                <Modal.Title>{this.state.title}</Modal.Title>
                            </div>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="row student-form__body">
                        {this.state.error && (
                            <div className="col-12">
                                <div className="student-form__alert" role="alert">
                                    <FeatherIcon icon="alert-circle" size="17" />
                                    <span>{this.state.error}</span>
                                </div>
                            </div>
                        )}
                        <div className="col-md-4">
                            <div className="col-12 student-form__section-title">
                                <span>
                                    <FeatherIcon icon="truck" size="16" />
                                </span>
                                <div>
                                    <strong>Fournisseur</strong>
                                    <small>Choisissez le fournisseur lié à ce don</small>
                                </div>
                            </div>

                            <div className="form-group col-md-12 mt-2">
                                <label className="font-monospace fw-normal">
                                    Fournisseur <span className="text-danger">*</span>
                                </label>
                                <Select
                                    {...selectMenuProps}
                                    className="form-control form-control-sm p-0"
                                    value={optionsuppliers.filter((option) => option.value === this.state.supplierId)}
                                    onChange={(select) =>
                                        this.setState((state) => ({
                                            supplierId: select.value,
                                            error: "",
                                            errors: { ...state.errors, supplierId: "" },
                                        }))
                                    }
                                    options={optionsuppliers}
                                />
                            </div>
                        </div>
                        
                        <div className="col-md-8">
                            <div className="col-12 student-form__section-title mt-3">
                                <span>
                                    <FeatherIcon icon="gift" size="16" />
                                </span>
                                <div>
                                    <strong>Informations du don</strong>
                                    <small>Titre, quantité, document et description</small>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-8 mt-2">
                                    <div className="form-group has-icon-left">
                                        <label className="font-monospace fw-normal" htmlFor="entitled-gift">
                                            Titre du don <span className="text-danger">*</span>
                                        </label>
                                        <div className="position-relative mt-1">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Ex : Bancs, livres, ordinateurs..."
                                                onChange={this.handleInput}
                                                name="entitled_gift"
                                                value={this.state.entitled_gift}
                                                id="entitled-gift"
                                                maxLength={100}
                                            />
                                            <div className="form-control-icon text-secondary">
                                                <FeatherIcon icon="box" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 mt-2">
                                    <div className="form-group has-icon-left">
                                        <label className="font-monospace fw-normal" htmlFor="gift-quantity">
                                            Quantité
                                        </label>
                                        <div className="position-relative mt-1">
                                            <input
                                                type="number"
                                                min="0"
                                                className="form-control form-control-sm"
                                                onChange={this.handleInput}
                                                name="quantity"
                                                value={this.state.quantity}
                                                id="gift-quantity"
                                            />
                                            <div className="form-control-icon text-secondary">
                                                <FeatherIcon icon="package" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 mt-2">
                                <label className="student-import-dropzone">
                                    <FeatherIcon icon="paperclip" size="19" />
                                    <span>
                                        <strong>
                                            {this.state.file
                                                ? this.state.file.name
                                                : this.state.oldFile
                                                    ? "Document actuel disponible"
                                                    : "Choisir un document"}
                                        </strong>
                                        <small>PDF, image ou document justificatif</small>
                                    </span>
                                    <input type="file" onChange={this.handleFile} />
                                </label>
                            </div>
                        </div>

                        <div className="col-12 mt-2">
                            <div className="form-group">
                                <label className="font-monospace fw-normal" htmlFor="gift-specification">
                                    Spécification et description
                                </label>
                                <textarea
                                    value={this.state.specification}
                                    onChange={this.handleInput}
                                    name="specification"
                                    rows={4}
                                    maxLength={1000}
                                    id="gift-specification"
                                    className="form-control"
                                    placeholder="Détaillez le don, son état, son usage ou toute information importante..."
                                />
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <span className="student-form__footer-note">
                            <FeatherIcon icon="info" size="14" /> Les champs marqués d’un * sont obligatoires
                        </span>

                        <button
                            type="button"
                            onClick={this.props.showModal}
                            className="btn btn-light student-form__button"
                            disabled={this.state.btn}
                        >
                            <FeatherIcon icon="x" size="16" /> Fermer
                        </button>

                        <button
                            type="button"
                            onClick={() => this.storeGift()}
                            className="btn btn-primary student-form__button"
                            disabled={this.state.btn}
                        >
                            <FeatherIcon icon="check" size="16" />
                            {this.state.btn ? "Enregistrement..." : "Sauvegarder"}
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default GiftForm;